import React, { useState, useEffect } from 'react';
import { FiChevronUp } from "react-icons/fi";
import Blury from '../Blury';

const ScrollTop = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const toggleVisible = () => {
            const scrolled = document.documentElement.scrollTop;
            if (!isMounted) return;
            setVisible(scrolled > 300);
        };
        window.addEventListener('scroll', toggleVisible);
        return () => {
            isMounted = false;
            window.removeEventListener('scroll', toggleVisible);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <>
            <div 
            className="rn-back-top" 
            onClick={scrollToTop}
            style={{display: visible ? 'inline' : 'none'}}
            ><FiChevronUp /></div>
            <Blury />
        </>
    )
}

export default ScrollTop;